import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { BrandingProvider } from './lib/branding.jsx';
import Dashboard from './admin/Dashboard.jsx';
import GalleryEditor from './admin/GalleryEditor.jsx';
import Library from './admin/Library.jsx';
import AdminLogin from './admin/AdminLogin.jsx';
import GalleryLayout from './client/GalleryLayout.jsx';
import GalleryHome from './client/GalleryHome.jsx';
import FilmPage from './client/FilmPage.jsx';
import PhotosPage from './client/PhotosPage.jsx';
import Portfolio from './client/Portfolio.jsx';
import { TvPairPage } from './client/WatchOnTv.jsx';
import './styles.css';

function NotFound() {
  return (
    <div className="centered">
      <div className="card narrow">
        <h1>Nothing here</h1>
        <p className="muted">This link may be mistyped or the gallery may have been removed.</p>
      </div>
    </div>
  );
}

/**
 * Old links used /gallery/<slug>. Galleries now live at the root, so anything
 * still pointing at the old shape is forwarded rather than 404'd — a link a
 * couple has already saved must never break.
 */
function LegacyGalleryLink() {
  const { slug, '*': rest } = useParams();
  return <Navigate to={`/${slug}${rest ? `/${rest}` : ''}`} replace />;
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <BrandingProvider>
        {/*
          Route order matters: galleries sit at the root as /:slug, so every real
          app path must be declared first. React Router ranks static segments
          above dynamic ones, and the server keeps its own reserved-slug list, so
          a gallery can never shadow /admin or /api.
        */}
        <Routes>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/library" element={<Library />} />
          <Route path="/admin/galleries/:id" element={<GalleryEditor />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/tv" element={<TvPairPage />} />
          <Route path="/gallery/:slug/*" element={<LegacyGalleryLink />} />
          <Route path="/:slug" element={<GalleryLayout />}>
            <Route index element={<GalleryHome />} />
            <Route path="film" element={<FilmPage />} />
            <Route path="photos" element={<PhotosPage />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrandingProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
